<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索国家" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchCountry } from '@/api/games/country';

export default {
    name: "country-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchCountry,
        }
    }
}
</script>

